export default __webpack_public_path__ + "static/media/TN.d646192c.svg";